export enum FamilyRelationshipEnum {
  FATHER = "FATHER",
  MOTHER = "MOTHER",
  CHILD = "CHILD",
  BROTHER = "BROTHER",
  SISTER = "SISTER",
  GRAND_FATHER = "GRAND_FATHER",
  GRAND_MOTHER = "GRAND_MOTHER",
  UNCLE = "UNCLE",
  AUNT = "AUNT",
  COUSIN = "COUSIN",
  FRIEND = "FRIEND",
}

export enum NonTraditionalGiftRelationshipEnum {
  UNCLE = "UNCLE",
  AUNT = "AUNT",
  COUSIN = "COUSIN",
  FRIEND = "FRIEND",
}

export enum EquityGiftRelationshipEnum {
  FATHER = "FATHER",
  MOTHER = "MOTHER",
  CHILD = "CHILD",
  BROTHER = "BROTHER",
  SISTER = "SISTER",
  GRAND_FATHER = "GRAND_FATHER",
  GRAND_MOTHER = "GRAND_MOTHER",
}

export enum CurrencyEnum {
  CAD = "CAD",
  USD = "USD",
}

export enum VehicleType {
  SEDAN = "SEDAN",
  SUV = "SUV",
  TRUCK = "TRUCK",
}
